module.exports = __webpack_public_path__ + "static/img/高频活跃的全场景运营服务阵地1.790f588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/高频活跃的全场景运营服务阵地1.png
// module id = V7Y6
// module chunks = 0